import {create} from "apisauce";
import qs from "qs";

import {makeAuthorizationHeader} from "../../utils/token";
import {asyncRequestTransform, responseTransform} from "./helpers";
import {getCommonAuthorizationHeader} from "./selectors";
import {Config} from "./consts";

let config: Config = null;

export const http = create({
  baseURL: process.env.REACT_APP_API_GATEWAY_URL,
  headers: {
    Accept: "application/json",
  },
  paramsSerializer: params =>
    qs.stringify(params, {
      arrayFormat: "repeat",
      skipNulls: true,
    }),
});

export function configureRestApiClient(cfg: Config) {
  config = cfg;
}

http.addAsyncRequestTransform(async request =>
  asyncRequestTransform(
    request,

    // Allow custom token to be passed for specific flows (e.g. fetching active theme with admission token). In that case, we don't have access to the store and can't use getCommonAuthorizationHeader(). That's why we pass the token directly through the request params.
    request.params?.token
      ? makeAuthorizationHeader(request.params.token)
      : getCommonAuthorizationHeader(),
  ),
);

http.addResponseTransform(response => responseTransform(response, config));
